<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Details from "@/router/views/property/components/details";
import AssignmentHistory from "@/router/views/property/components/assignmenthistory";
import Attachments from "@/router/views/property/components/attachments";
import RawData from "@/components/widgets/raw-data.vue";

export default {
  page: {
    title: "Expired"
  },
  components: {
    Layout,
    PageHeader,
    Details,
    AssignmentHistory,
    Attachments,
    RawData
  },
  data() {
    return {
      title: "Expired",
      submitted: false,
      items: [
        {
          text: "Dashboards",
          href: "/"
        },
        {
          text: "Expired",
          active: true
        }
      ],
      tableData: [],
      modalTitle: "",
      currentPage: 1,
      perPage: 10,
      pageOptionsLg: [10, 25, 50, 100],
      pageOptionsSm: [5, 10, 20, 50],
      filter: "",
      filterOn: [],
      sortBy: "id",
      sortDesc: true,
      fields: [
        {
          key: "poNumber",
          sortable: true,
          label: "Purchase Order"
        }
      ],
      propertyFields: [
        {
          key: "Name",
          sortable: true
        }
      ],
      poIndex: -1,
      propertyIndex: -1,
      itemIndex: -1,
      tableBusy: false,
      campusId: this.$store.state.data.selectedCampus.id,
      accountableEmployee: null
    };
  },
  computed: {
    filtered() {
      let data = this.tableData;
      if (this.filter.trim() != "" && this.filter) {
        data = data.filter((item) => {
          if (this.bySearch) {
            if (item.name.toUpperCase().includes(this.filter.toUpperCase())) {
              return item.name
                .toUpperCase()
                .includes(this.filter.toUpperCase());
            } else if (
              item.propertyNumber
                .toUpperCase()
                .includes(this.filter.toUpperCase())
            ) {
              return item.propertyNumber
                .toUpperCase()
                .includes(this.filter.toUpperCase());
            } else if (
              item.serialNumber
                .toUpperCase()
                .includes(this.filter.toUpperCase())
            ) {
              return item.serialNumber
                .toUpperCase()
                .includes(this.filter.toUpperCase());
            } else if (
              item.currentAssignment &&
              item.currentAssignment.assignmentNumber
                .toUpperCase()
                .includes(this.filter.toUpperCase())
            ) {
              return item.currentAssignment.assignmentNumber
                .toUpperCase()
                .includes(this.filter.toUpperCase());
            }
          } else {
            if (
              item.poNumber.toUpperCase().includes(this.filter.toUpperCase())
            ) {
              return item.poNumber
                .toUpperCase()
                .includes(this.filter.toUpperCase());
            } else if (
              item.supplier.toUpperCase().includes(this.filter.toUpperCase())
            ) {
              return item.supplier
                .toUpperCase()
                .includes(this.filter.toUpperCase());
            }
          }
        });
      }
      return data;
    },
    rows() {
      if (this.filter.trim() != "" && this.filter) {
        return this.filtered.length;
      } else {
        return this.tableData.length;
      }
    }
  },
  created() {
    this.changeData(this.$store.state.data.selectedCampus.id);
  },
  methods: {
    async changeData(campusId) {
        this.tableBusy = true;
        await this.getExpiredProperties(campusId);
        this.tableBusy = false;
    },
    async getExpiredProperties(campusId) {
      await this.$store
        .dispatch("property/GetExpiredProperties", campusId)
        .then((res) => {
            if(res.data.error){
                return this.showToast(res.data.errorMessage, "error");
            }
          res.data.forEach((item) => {
            item.details = [];
            item.showDetails = false;
            item.rotateChevy = false;
            item.currentPage = 1;
            item.perPage = 5;
            item.filter = "";
            item.tableBusy = false;
          });
          this.tableData = res.data;
        })
        .catch(() => {
          this.showToast("Something went wrong - Getting expired property list!", "error");
        });
    },
    getProperty(row) {
      row.item.rotateChevy = !row.item.rotateChevy;
      row.item.showDetails = !row.item.showDetails;
      row.item.details = [];
      if (row.item.showDetails) {
        row.item.tableBusy = true;
        setTimeout(() => {
          var poNumber = row.item.poNumber;
          var status = "EXPIRED"; // Changed from PENDING to EXPIRED
          var campusId = this.campusId;
          this.$store
            .dispatch("property/GetPropertybyPO", {
              poNumber,
              status,
              campusId
            })
            .then((res) => {
              res.data.forEach((item) => {
                item.visible = false;
                item.itemVisible = false;
                item.assignmentHistory = [];
                item.assignVisible = false;
                item.assignLoading = false;
                item.attachmentVisible = false;
                item.addDocu = false;
                item.attachmentLoading = false;
                item.fileSearch = "";
                item.toggleSelected = false;
              });
              row.item.details = res.data;
              row.item.tableBusy = false;
            })
            .catch(() => {
              row.item.tableBusy = false;
              this.showToast(
                "Something went wrong - Getting property by PO!",
                "error"
              );
            });
        }, 1000);
      }
    },
    propertyFiltered(row) {
      let data = row.details;
      if (row.filter.trim() != "" && row.filter) {
        data = data.filter((item) => {
          if (item.name.toUpperCase().includes(row.filter.toUpperCase())) {
            return item.name.toUpperCase().includes(row.filter.toUpperCase());
          } else if (
            item.propertyNumber.toUpperCase().includes(row.filter.toUpperCase())
          ) {
            return item.propertyNumber
              .toUpperCase()
              .includes(row.filter.toUpperCase());
          } else if (
            item.serialNumber.toUpperCase().includes(row.filter.toUpperCase())
          ) {
            return item.serialNumber
              .toUpperCase()
              .includes(row.filter.toUpperCase());
          } else if (
            item.currentAssignment &&
            item.currentAssignment.assignmentNumber
              .toUpperCase()
              .includes(row.filter.toUpperCase())
          ) {
            return item.currentAssignment.assignmentNumber
              .toUpperCase()
              .includes(row.filter.toUpperCase());
          }
        });
      }
      return data;
    },
    propertyRows(row) {
      if (row.filter.trim() != "" && row.filter) {
        return this.propertyFiltered(row).length;
      } else {
        return row.details.length;
      }
    },
    showDtls(row) {
      row.item.rotateChevy = !row.item.rotateChevy;
      if (row.item.showDetails) {
        row.item.showDetails = !row.item.showDetails;
        setTimeout(() => {
          row.toggleDetails();
        }, 600);
      } else {
        row.toggleDetails();
        setTimeout(() => {
          row.item.showDetails = !row.item.showDetails;
        }, 50);
      }
    },
    propertyNumberWidth(number) {
      if (number < 100) return "min-width: 35px";
      else if (number < 1000) return "min-width: 50px";
      else if (number < 10000) return "min-width: 60px";
      else return "min-width: 75px";
    }
  }
};
</script>

<template>
  <Layout @changeCampus="changeData($event.id)">
    <PageHeader :title="title" :items="items" />
    <!-- View Employee Info -->
    <b-modal
      id="modal-accountableEmployee"
      :title="modalTitle"
      size="md"
      title-class="font-18"
      hide-footer
      no-close-on-backdrop
    >
      <div v-if="accountableEmployee && accountableEmployee.firstName">
        <div class="d-flex align-items-center">
          <div class="avatar-sm me-2">
            <span
              class="avatar-title rounded-circle bg-soft-primary text-primary font-size-16"
              >{{ accountableEmployee.lastName.charAt(0).toUpperCase() }}</span
            >
          </div>
          <div>
            <div class="mt-1">
              {{ accountableEmployee.firstName }}
              {{ accountableEmployee.lastName }}
            </div>
            <div>{{ accountableEmployee.idNo }}</div>
          </div>
        </div>
        <hr class="my-3" />
        <div class="ps-3 pe-3">
          <b-row class="mb-2">
            <b-col class="p-0" sm="2">
              <strong>Position:</strong>
            </b-col>
            <b-col
              >{{ accountableEmployee.position }}</b-col
            >
          </b-row>
          <b-row class="mb-2">
            <b-col class="p-0" sm="2">
              <strong>Office:</strong>
            </b-col>
            <b-col
              >{{ accountableEmployee.office }}</b-col
            >
          </b-row>
        </div>
        <hr class="my-3" />
      </div>
    </b-modal>
    <!-- Main -->
    <div
      class="card border-4 border-top border-start-0 border-end-0 border-primary"
    >
      <div class="card-body">
        <div class="row mb-3">
          <div class="col-md-6">
            <div class="d-flex align-items-center h-100">
              <h4 class="card-title mb-0">Expired Properties</h4>
            </div>
          </div>
          <div class="col-md-6">
            <!-- Removed action buttons from here -->
          </div>
        </div>
        <div class="row mb-1">
          <div class="col-md-6"></div>
          <div class="col-md-6">
            <div class="d-flex float-end">
              <div class="search-box me-2 mb-2 d-inline-block">
                <div class="position-relative">
                  <label for="search-bar" class="sr-only">Search</label>
                  <input
                    id="search-bar"
                    type="text"
                    v-model="filter"
                    class="form-control"
                    placeholder="Search..."
                  />
                  <i class="bx bx-search-alt search-icon"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="custom-table-responsive mb-0 mt-2">
          <b-table
            class="propertyTable datatables target-table"
            :items="filtered"
            :fields="fields"
            responsive="sm"
            :per-page="perPage"
            :current-page="currentPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :busy="tableBusy"
            bordered
            striped
            show-empty
          >
            <template #empty>
              <b-card-header>
                <div class="text-center">
                  <div v-if="filter != ''">
                    <i class="fas fa-exclamation-triangle me-2"></i>There are no
                    POs matching your request
                  </div>
                  <div v-else>
                    <i class="fas fa-exclamation-triangle me-2"></i>No POs
                    available
                  </div>
                </div>
              </b-card-header>
            </template>
            <template #table-busy>
              <b-card-header>
                <div class="d-flex justify-content-center align-items-center">
                  <div class="preloader-component me-2">
                    <div class="status">
                      <div class="spinner-chase w-20px h-20px">
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                      </div>
                    </div>
                  </div>
                  <strong>Loading...</strong>
                </div>
              </b-card-header>
            </template>
            <template #cell(poNumber)="row">
              <b-card-header
                header-tag="header"
                @click="getProperty(row)"
                class="cursor-pointer border position-relative"
                role="tab"
              >
                <RawData :data="row.item" v-if="$store.state.decrypt.isAdmin()" />
                <div class="d-flex justify-content-between align-items-center">
                  <div>
                    <b class="text-white">{{
                      row.value ? `PO# ${row.value}` : "No Recorded PO"
                    }}</b>
                    <div>
                      {{
                        row.item.supplier
                          ? row.item.supplier
                          : "No Recorded Supplier"
                      }}
                    </div>
                  </div>
                  <div>
                    <i
                      class="bx bx-chevron-right rotate font-size-16 cursor-pointer"
                      :class="{
                        'rotate-90': row.item.rotateChevy
                      }"
                    ></i>
                  </div>
                </div>
              </b-card-header>
              <b-collapse :visible="row.item.showDetails">
                <div v-if="row.item.showDetails">
                  <b-card
                    no-body
                    class="p-3 shadow-none mb-0 border-5 border-top-0 border-start-0 border-end-0"
                  >
                    <div class="d-flex justify-content-between mb-1">
                      <div class="d-flex">
                        <div
                          id="tickets-table_filter"
                          class="dataTables_filter me-1"
                        >
                          <label class="d-inline-flex align-items-center">
                            <b-form-input
                              autocomplete="off"
                              v-model="row.item.filter"
                              type="search"
                              placeholder="Search Property..."
                              class="form-control form-control-sm"
                            ></b-form-input>
                          </label>
                        </div>
                        <div
                          id="tickets-table_length"
                          class="dataTables_length"
                        >
                          <label class="d-inline-flex align-items-center mb-0">
                            <b-form-select
                              class="form-select form-select-sm"
                              v-model="row.item.perPage"
                              size="sm"
                              :options="pageOptionsSm"
                            >
                            </b-form-select>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="mb-0">
                      <b-table
                        class="propertyTable datatables target-table"
                        thead-class="d-none"
                        :items="propertyFiltered(row.item)"
                        :fields="propertyFields"
                        responsive="sm"
                        :per-page="row.item.perPage"
                        :current-page="row.item.currentPage"
                        sort-by="id"
                        :sort-desc="false"
                        :busy="row.item.tableBusy"
                        show-empty
                      >
                        <template #empty>
                          <b-card-header>
                            <div class="text-center">
                              <div v-if="row.item.filter != ''">
                                <i class="fas fa-exclamation-triangle me-2"></i
                                >There are no properties matching your request
                              </div>
                              <div v-else>
                                <i class="fas fa-exclamation-triangle me-2"></i
                                >No properties available
                              </div>
                            </div>
                          </b-card-header>
                        </template>
                        <template #table-busy>
                          <b-card-header>
                            <div
                              class="d-flex justify-content-center align-items-center p-2"
                            >
                              <div class="preloader-component me-2">
                                <div class="status">
                                  <div class="spinner-chase w-20px h-20px">
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                  </div>
                                </div>
                              </div>
                              <strong>Loading...</strong>
                            </div>
                          </b-card-header>
                        </template>
                        <template #cell(name)="propertyRow">
                          <div class="position-relative ms-1">
                            <RawData
                              :data="propertyRow.item"
                              v-if="$store.state.decrypt.isAdmin()"
                            />
                          </div>
                          <b-card-header
                            header-tag="header"
                            role="tab"
                            class="border"
                          >
                            <div
                              class="d-flex justify-content-between align-items-center"
                            >
                              <div class="d-flex align-items-center pe-5">
                                <div class="text-muted">
                                  <h5 class="mb-0">
                                    {{ propertyRow.item.name }}
                                  </h5>
                                  <div style="min-width: max-content">
                                    <small class="d-flex align-items-center">
                                      {{
                                        propertyRow.item.propertyNumber &&
                                        propertyRow.item.propertyNumber !=
                                          "Not Indicated"
                                          ? `Property# ${propertyRow.item.propertyNumber}`
                                          : "Not Indicated"
                                      }}
                                      |
                                      <a
                                        href="javascript: void(0);"
                                        class="text-success d-flex align-items-center ms-1"
                                        @click="
                                          propertyRow.item.visible = !propertyRow
                                            .item.visible
                                        "
                                      >
                                        {{
                                          propertyRow.item.visible
                                            ? "Hide"
                                            : "Show"
                                        }}
                                        Details
                                        <i
                                          class="bx bx-chevron-right rotate font-size-14"
                                          :class="{
                                            'rotate-90':
                                              propertyRow.item.visible
                                          }"
                                        ></i>
                                      </a>
                                    </small>
                                  </div>
                                </div>
                              </div>
                              <div
                                class="d-flex justify-content-between align-items-center ms-5"
                              >
                                <div
                                  style="width: 200px"
                                  class="d-flex align-items-center"
                                >
                                  <div class="text-muted">
                                    <div>
                                      <small class="d-flex align-items-center">
                                        Current Value:
                                      </small>
                                    </div>
                                    <h6 class="mb-0 text-warning">
                                      {{
                                        formatCurrency(
                                          propertyRow.item.currentValue
                                        )
                                      }}
                                    </h6>
                                  </div>
                                </div>
                                <div
                                  class="float-end d-flex align-items-center ms-3"
                                >
                                  <i
                                    class="fas fa-ellipsis-v cursor-pointer ps-2 pe-2 ms-2"
                                    :id="
                                      `register-popover-${propertyRow.item.id}`
                                    "
                                    tabindex="0"
                                  ></i>
                                  <b-popover
                                    :target="
                                      `register-popover-${propertyRow.item.id}`
                                    "
                                    triggers="click blur"
                                    placement="leftbottom"
                                    variant="secondary"
                                    custom-class="p-0"
                                  >
                                    <b-list-group class="w-100 fit">
                                      <b-list-group-item
                                        button
                                        action
                                        class="d-flex align-items-center text-info"
                                        @click="updateItem(propertyRow.item)"
                                        ><i
                                          class="mdi mdi-update font-size-18 me-1"
                                        ></i
                                        >Update Item</b-list-group-item
                                      >
                                      <b-list-group-item
                                        button
                                        action
                                        class="d-flex align-items-center text-success"
                                        @click="postItem(propertyRow.item)"
                                        ><i
                                          class="bx bx-list-check font-size-18 me-1"
                                        ></i
                                        >Post Now</b-list-group-item
                                      >
                                      <b-list-group-item
                                        v-if="propertyRow.item.iarItemId == 0"
                                        button
                                        action
                                        class="d-flex align-items-center text-danger"
                                        @click="deleteItem(propertyRow.item)"
                                        ><i
                                          class="mdi mdi-trash-can font-size-18 me-1"
                                        ></i
                                        >Delete</b-list-group-item
                                      >
                                    </b-list-group>
                                  </b-popover>
                                </div>
                              </div>
                            </div>
                          </b-card-header>
                          <b-collapse
                            :visible="propertyRow.item.visible"
                            role="tabpanel"
                          >
                            <div v-if="propertyRow.item.visible">
                              <b-card
                                no-body
                                class="shadow-none mb-0 border-5 border-top-0 border-start-0 border-end-0"
                              >
                                <Details
                                  :key="`details-${propertyRow.item.id}`"
                                  :propertyRow="propertyRow.item"
                                  :ref="`details-${propertyRow.item.id}`"
                                ></Details>
                                <AssignmentHistory
                                  :key="`assignment-${propertyRow.item.id}`"
                                  :propertyRow="propertyRow.item"
                                  :allowAssign="false"
                                  :allowEdit="true"
                                  :allowTransfer="true"
                                  :employeeData="assignmentHistoryEmployeeData"
                                  :locationData="assignmentHistoryLocationData"
                                  :ref="`assignment-${propertyRow.item.id}`"
                                  @getEmployee="getEmployee($event)"
                                  @getLocation="getLocation($event)"
                                ></AssignmentHistory>
                                <Attachments
                                  :key="`attachments-${propertyRow.item.id}`"
                                  :propertyRow="propertyRow.item"
                                  :ref="`attachments-${propertyRow.item.id}`"
                                ></Attachments>
                              </b-card>
                            </div>
                          </b-collapse>
                        </template>
                      </b-table>
                    </div>
                    <div class="row">
                      <div v-if="propertyRows(row.item) > 0" class="col">
                        Showing
                        {{ (row.item.currentPage - 1) * row.item.perPage + 1 }}
                        -
                        {{
                          propertyRows(row.item) >
                          (row.item.currentPage - 1) * row.item.perPage +
                            row.item.perPage
                            ? (row.item.currentPage - 1) * row.item.perPage +
                              row.item.perPage
                            : propertyRows(row.item)
                        }}
                        of {{ propertyRows(row.item) }}
                      </div>
                      <div class="col">
                        <div
                          @click="resetToggle(row.item)"
                          class="dataTables_paginate paging_simple_numbers float-end"
                        >
                          <ul
                            class="pagination pagination-rounded mb-0"
                            style="z-index: -1"
                          >
                            <b-pagination
                              v-model="row.item.currentPage"
                              :total-rows="propertyRows(row.item)"
                              :per-page="row.item.perPage"
                            ></b-pagination>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </b-card>
                </div>
              </b-collapse>
            </template>
          </b-table>
        </div>
        <div class="row">
          <div v-if="rows > 0" class="col">
            Showing {{ (currentPage - 1) * perPage + 1 }} -
            {{
              Math.min(currentPage * perPage, rows)
            }}
            of {{ rows }}
          </div>
          <div class="col">
            <div
              class="dataTables_paginate paging_simple_numbers float-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                align="fill"
                size="sm"
                class="pagination pagination-rounded justify-content-end mb-2"
              ></b-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.p-0 .popover-body {
  padding: 0 !important;
}

.tooltip {
  opacity: 1 !important;
}

.v-enter-active {
  animation: slide-in 0.3s;
}

.v-leave-active {
  animation: slide-in 0.3s reverse;
}

@keyframes slide-in {
  0% {
    transform: translateX(-10px);
    opacity: 0;
  }

  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

.propertyTable tr td {
  padding: 0 !important;
  margin: 0 !important;
}
</style>